import React, { useCallback, useRef } from "react";

const COLORS = ["#D4AF37", "#F4E4C1", "#E07A5F", "#F8DCD0", "#FFD8B5"];

export const SparkleBurst = ({ children, className = "", as: Tag = "span", count = 14, ...props }) => {
    const ref = useRef(null);

    const burst = useCallback(
        (e) => {
            const el = ref.current;
            if (!el) return;
            const rect = el.getBoundingClientRect();
            const cx = (e.clientX || rect.left + rect.width / 2) - rect.left;
            const cy = (e.clientY || rect.top + rect.height / 2) - rect.top;
            for (let i = 0; i < count; i++) {
                const s = document.createElement("span");
                const size = 6 + Math.random() * 10;
                const dx = (Math.random() - 0.5) * 140;
                const dy = -40 - Math.random() * 80;
                s.className = "sparkle-particle";
                s.style.left = `${cx}px`;
                s.style.top = `${cy}px`;
                s.style.width = `${size}px`;
                s.style.height = `${size}px`;
                s.style.setProperty("--dx", `${dx}px`);
                s.style.setProperty("--dy", `${dy}px`);
                s.style.background = COLORS[i % COLORS.length];
                s.style.borderRadius = "50%";
                s.style.boxShadow = `0 0 ${size}px ${COLORS[i % COLORS.length]}`;
                s.style.animationDelay = `${Math.random() * 80}ms`;
                el.appendChild(s);
                setTimeout(() => s.remove(), 1200);
            }
        },
        [count]
    );

    return (
        <Tag
            ref={ref}
            onClick={burst}
            className={`relative inline-flex overflow-visible ${className}`}
            {...props}
        >
            {children}
        </Tag>
    );
};

export default SparkleBurst;
